import { render } from "./UiPropSelect.vue?vue&type=template&id=5bfe63b8"
import script from "./UiPropSelect.vue?vue&type=script&lang=js"
export * from "./UiPropSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__